import type { SlotDataResponse } from './types';

export function adaptSlotData(raw: unknown, slotKey: string): SlotDataResponse {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<SlotDataResponse>;
  return {
    slot_key: String(data.slot_key || slotKey),
    items: Array.isArray(data.items) ? data.items : [],
  };
}
